import React from 'react'
import globals from '../../globals.json';

export default function Pager(props) {
  return (
    <div className={`Pager ${props.data.class}`}>

      {/* optional 'extras' fields - creates divs from  extras array that looks like: [{'class':"some class", "content":"Some content"}]*/}
      {props.data.extras && props.data.extras.map((extra, i) => {
        return <div className={`extra ${extra.class} extra-${i}`}>
          <div className="text" dangerouslySetInnerHTML={{__html: extra.content}} />
        </div>
      })}

      <div className="text-content" dangerouslySetInnerHTML={{__html: props.data.content}} />
      <button
        className="global-button"
        onClick={props.onComplete}>
        {props.data.button || globals.nextButtonText}
      </button>
    </div>
  )
}
